// extracted by mini-css-extract-plugin
export default {"ctn":"Footer_ctn_dsHE1","text":"Footer_text_MUk_c","crumbs":"Footer_crumbs_cgCJp","name":"Footer_name_YwWKv"};